export default __webpack_public_path__ + "static/media/profile-pic.305d39a5.jpeg";